import React, {PureComponent} from "react";
import FJPageHeader from "fj-components/FJPageHeader";
import FJPlaceholder from './FJPlaceholder'
import FJResourcesElementCommon from "./FJResourcesElementCommon";
import styles from './FJResourcesElementList.module.less'
import FJCustomScroll from "fj-components/FJCustomScroll";
import FJLocalStore from "../../../store/FJLocalStore";
import FJHorizontalScrollerIncludeArrowButton from "./FJHorizontalScrollerIncludeArrowButton";
import InlineSVG from "react-inlinesvg";
import rightSvg from '../../../icon/right.svg';
import FJCoreUtil from "../../../core/util/FJCoreUtil";
import FJMediaItemPlaceholder from "./FJMediaItemPlaceholder";
import FJLazyScroll from "./FJLazyScroll";
import classNames from 'classnames'

class FJResourcesElementList extends PureComponent {

  _allSeeMore = {};
  _allPageHeaderChildren = {};
  _leftClick = (category, number) => {
    this[`_scroller${category}`].scrollLeftStep(-number)
    return (this[`_scroller${category}`].getScrollLeft(true) <= number || this[`_scroller${category}`].getScrollLeft(true) === 0);
  }

  _rightClick = (category, number) => {
    let scroll = this[`_scroller${category}`].getScroll();
    let {clientWidth, scrollWidth} = scroll.current.getValues();
    this[`_scroller${category}`].scrollLeftStep(number)
    return (this[`_scroller${category}`].getScrollLeft(true) + clientWidth + number) >= scrollWidth;
  }

  _getCollectionList = (activeList) => {
    let {seeMore, allResourcesElement, seeAllText, classes, hasInit} = this.props;
    let items = [];
    let index = -1;
    for (let i in allResourcesElement) {
      if (allResourcesElement.hasOwnProperty(i)) {
        index++;
        let item = allResourcesElement[i];
        let onSeeMore = this._allSeeMore[i] || (() => {
          seeMore(i, i)
        });
        this._allSeeMore[i] = onSeeMore;
        let children = this._allPageHeaderChildren[i] || this._renderList(item, this.props.isShow, i);
        this._allPageHeaderChildren[i] = hasInit && children;
        items.push(
          <div key={i} style={{width: '100%', height: '156px'}}>
            <FJPlaceholder active={index >= activeList[0] && index <= activeList[1]}>
              <FJPageHeader title={FJLocalStore._(i)}
                            id={i}
                            onClick={onSeeMore}
                            seeAllText={seeAllText}
                            classes={classes.pageHeaderClasses}
                            hasSeeAll={item.length > 3}
                            hasIcon={false}
              >
                {children}
              </FJPageHeader>
            </FJPlaceholder>
          </div>
        );
      }
    }

    return items;
  }

  _getItems = (list) => {

    let {
      onAddClick,
      onHandleClick,
      resourceViewInfo,
      classes,
      onMediaDrag,
      config,
      allTooltip,
      toggleTooltip,
      oneTooltip,
      hasInit,
      chooseMediaIdList
    } = this.props;

    let {
      width,
      height,
      space,
      marginBottom,
      marginTop,
      marginLeft
    } = resourceViewInfo;

    let {
      addIcon,
      deleteIcon,
      activeColor,
      addIconToolTip
    } = config;

    let items = [];

    let column = 15;

    list.forEach((item, index) => {
      if ((index + 1) <= column) {
        items.push(
          hasInit ?
            <FJResourcesElementCommon
              key={item.id}
              id={item.id}
              width={width}
              height={height}
              marginRight={(index + 1) % column === 0 ? 0 : space}
              marginBottom={marginBottom}
              marginTop={marginTop}
              thumbnail={item.thumbnail}
              url={item.url}
              name={item.title}
              hasName={false}
              type={item.type}
              fromType={item.fromType}
              hasAddBtn
              onAddClick={onAddClick}
              selectMedia={onHandleClick}
              classes={classes.itemClasses}
              activeColor={activeColor}
              addIcon={addIcon}
              deleteIcon={deleteIcon}
              onMediaDrag={onMediaDrag}
              addIconToolTip={addIconToolTip}
              allTooltip={allTooltip}
              toggleTooltip={toggleTooltip}
              oneTooltip={oneTooltip}
              isChoose={chooseMediaIdList.indexOf(item.id) !== -1}
              authorItem={item.authorItem}
              marginLeft={marginLeft}
            /> : <FJMediaItemPlaceholder width={90} height={90} key={item.id}/>
        )
      }
    });

    return items;
  }

  _renderList = (list, active, category) => {

    let classes = {
      trackVertical: styles.displayNoneTrackVertical,
      trackHorizontal: styles.displayNoneTrackHorizontal,
      thumbVertical: '',
      thumbHorizontal: '',
      itemClasses: {
        resourceItemBox: '',
        resourceItemActive: '',
        inner: styles.inner_box
      }
    };

    let {seeMore} = this.props;

    return (
      <FJHorizontalScrollerIncludeArrowButton scrollerStyle={{width: "100%", height: '128px'}}
                                              hasShadow={true}
                                              rightClick={this._rightClick}
                                              leftClick={this._leftClick}
                                              category={category}
                                              length={list.length}
      >
        <FJCustomScroll classes={classes} ref={ref => {
          this[`_scroller${category}`] = ref
        }}>
          <div className={styles.cate_list}>
            {this._getItems(list, active)}
            {
              list.length > 3 && (
                <div className={styles.btn_box}>
                  <div className={styles.right_icon_box} onClick={() => {
                    seeMore(category, category)
                  }}>
                    <InlineSVG src={rightSvg}/>
                  </div>
                </div>
              )
            }
          </div>
        </FJCustomScroll>
      </FJHorizontalScrollerIncludeArrowButton>
    )
  }

  _onScroll = () => {
    FJCoreUtil.triggerBodyMousedown();
  };

  render() {
    let {isShow, classes} = this.props
    return (
      <div className={classNames(styles.list_box, {[styles.shown]: isShow})}>
        <FJLazyScroll itemHeight={156}
                      classes={classes.scrollClasses}
                      render={this._getCollectionList}
                      onScroll={this._onScroll} />
      </div>
    )
  }

}

export default FJResourcesElementList;